// taskConstants.js

const SECTIONS = {
    1: 'Overall Progress',
    2: 'Project Initiation',
    3: 'Design & Engineering',
    4: 'Statutory Approvals',
    5: 'Procurement',
    6: 'Site Mobilization',
    7: 'Civil Works',
    8: 'Mounting Structure Installation',
    9: 'Module Installation',
    10: 'DC Cabling & String Formation',
    11: 'Inverter and AC Works',
    12: 'SCADA and Communication',
    13: 'Testing & Commissioning',
    14: 'Handover & Documentation'
};


export const GROUND_MOUNT_TASKS = {
    india: [
        // Project Initiation
        { key: 'internalProject', name: 'Internal project kickoff', srNo: '1.0' },
        { key: 'defineProjectScope', name: 'Define project scope and budget', srNo: '1.1' },
        { key: 'assignProject', name: 'Assign project team and responsibilities', srNo: '1.2' },
        { key: 'landAcquisition', name: 'Land Acquisition', srNo: '1.3' },
        { key: 'siteSurveySoilTesting', name: 'Site Survey, soil testing and other initial assessment', srNo: '1.4' },
        { key: 'feasibiltiy', name: 'Feasibiltiy Study Report', srNo: '1.5' },
        { key: 'approvalFromManagement', name: 'Approval from Management', srNo: '1.6' },

        // Design & Engineering
        { key: 'topographicalSurvey', name: 'Topographical survey', srNo: '2.0' },
        { key: 'geotechnicalInvestigation', name: 'Geotechnical investigation', srNo: '2.1' },
        { key: 'preparationOfLayoutDrawings', name: 'Preparation of layout drawings', srNo: '2.2' },
        { key: 'preparationOfElectrical', name: 'Preparation of electrical SLDs', srNo: '2.3' },
        { key: 'stringDesignAndInverterSizing', name: 'String design and inverter sizing', srNo: '2.4' },
        { key: 'foundationAndStructuralDesign', name: 'Foundation and structural design', srNo: '2.5' },
        { key: 'finalizationOfDrawings', name: 'Finalization of Drawings', srNo: '2.6' },

        // Statutory Approvals
        { key: 'ceigDrawingSubmission', name: 'CEIG drawing submission and review', srNo: '3.0' },
        { key: 'disconLoadFlowStudy', name: 'DISCOM load flow study request', srNo: '3.1' },
        { key: 'sldcOpenAccessApproval', name: 'SLDC open access approval', srNo: '3.2' },
        { key: 'transmission/evacuationPermission', name: 'Transmission/evacuation permission', srNo: '3.3' },
        { key: 'environmentalClerance', name: 'Environmental clearance (if applicable)', srNo: '3.4' },
        { key: 'constructionPowerApplication', name: 'Construction power application', srNo: '3.5' },
        { key: 'snaProjectRegistration', name: 'SNA Project Registration Approval (if Applicable)', srNo: '3.6' },

        // Procurement
        { key: 'tendering&VenderFinalization', name: 'Tendering & Vender Finalization', srNo: '4.0' },
        { key: 'poReleases&AdvancePayment', name: 'PO Releases & Advance Payment', srNo: '4.1' },
        { key: 'procurementOfStructures', name: 'Procurement of Structures', srNo: '4.2' },
        { key: 'procurementOfModules', name: 'Procurement of Modules', srNo: '4.3' },
        { key: 'procurementOfInverters', name: 'Procurement of Inverters', srNo: '4.4' },
        { key: 'procurementOfCables,scb,ltpanels', name: 'Procurement of cables, SCB, LT Panels', srNo: '4.5' },
        { key: 'logistices', name: 'Logistics & Delivery', srNo: '4.6' },

        // Site Mobilization
        { key: 'siteOfficeSetup', name: 'Site office setup', srNo: '5.0' },
        { key: 'materialUnloadingAreaPreparation', name: 'Material unloading area preparation', srNo: '5.1' },
        { key: 'temporaryWaterAndElectricityArrangement', name: 'Temporary water and electricity arrangement', srNo: '5.2' },
        { key: 'safetyEquipmentDeployment', name: 'Safety equipment deployment', srNo: '5.3' },

        // Civil Works
        { key: 'siteGradingAndLeveling', name: 'Site grading and leveling', srNo: '6.0' },
        { key: 'foundationMarkingAndExcavation', name: 'Foundation marking and excavation', srNo: '6.1' },
        { key: 'rccFoundationCasting', name: 'RCC foundation casting', srNo: '6.2' },
        { key: 'inverterRoom', name: 'Inverter room/control room civil works', srNo: '6.3' },
        { key: 'cableTrenceExcavation', name: 'Cable trench excavation and concreting', srNo: '6.4' },

        // Mounting Structure Installation
        { key: 'structureUnloadingAndQuality', name: 'Structure unloading and quality inspection', srNo: '7.0' },
        { key: 'structureAssemblyAndErection', name: 'Structure assembly and erection', srNo: '7.1' },
        { key: 'verticalityAndAlignmentCheck', name: 'Verticality and alignment check', srNo: '7.2' },
        { key: 'nut-boltTightening', name: 'Nut-bolt tightening and torque check', srNo: '7.3' },

        // Module Installation
        { key: 'moduleUnloadingAndInspection', name: 'Module unloading and inspection', srNo: '8.0' },
        { key: 'moduleMountingOnStructures', name: 'Module mounting on structures', srNo: '8.1' },
        { key: 'torquingOfModules', name: 'Torquing of modules', srNo: '8.2' },
        { key: 'cleaningAndVisualInspection', name: 'Cleaning and visual inspection', srNo: '8.3' },

        // DC Cabling & String Formation
        { key: 'dcCableLaying', name: 'DC cable laying', srNo: '9.0' },
        { key: 'mc4ConnectorCrimping', name: 'MC4 connector crimping', srNo: '9.1' },
        { key: 'stringFormationAndTagging', name: 'String formation and tagging', srNo: '9.2' },
        { key: 'polarityAndInsulationResistanceTesting', name: 'Polarity and insulation resistance testing', srNo: '9.3' },

        // Inverter and AC Works
        { key: 'inverterPlacementAndMounting', name: 'Inverter placement and mounting', srNo: '10.0' },
        { key: 'acdbltPanelInstallation', name: 'ACDB, LT Panel installation', srNo: '10.1' },
        { key: 'acCableLayingAndTermination', name: 'AC cable laying and termination', srNo: '10.2' },
        { key: 'transformeInstallationIF', name: 'Transformer installation (if applicable)', srNo: '10.3' },
        { key: 'earthingAndLaInstallation', name: 'Earthing and LA installation', srNo: '10.4' },

        // SCADA and Communication
        { key: 'weatherStationInstallation', name: 'Weather station installation', srNo: '11.0' },
        { key: 'scadaPanelAndEquipmentMounting', name: 'SCADA panel and equipment mounting', srNo: '11.1' },
        { key: 'fiber/Cable Laying for Communication', name: 'Fiber/cable laying for communication', srNo: '11.2' },
        { key: 'systemIntegrationAndTesting', name: 'System integration and testing', srNo: '11.3' },

        // Testing & Commissioning
        { key: 'pre-CommissioningChecks', name: 'Pre-commissioning checks (IR, polarity)', srNo: '12.0' },
        { key: 'functionalTestionOfInverters', name: 'Functional testing of inverters', srNo: '12.1' },
        { key: 'ceigInspectionandClearance', name: 'CEIG inspection and clearance', srNo: '12.2' },
        { key: 'gridSynchronization', name: 'Grid synchronization', srNo: '12.3' },

        // Handover & Documentation
        { key: 'as-BuiltDrawingPreparation', name: 'As-built drawing preparation', srNo: '13.0' },
        { key: 'materialReconciliation', name: 'Material reconciliation', srNo: '13.1' },
        { key: 'o&mHandoverAndTraining', name: 'O&M handover and training', srNo: '13.2' },
        { key: 'clientHandoverWithSign-Off', name: 'Client handover with sign-off', srNo: '13.3' }
    ],
    dubai: [
        // Project Initiation
        { key: 'internalKickoff', name: 'Internal project kickoff', srNo: '1.0' },
        { key: 'defineScopeBudget', name: 'Define project scope and budget', srNo: '1.1' },
        { key: 'assignTeam', name: 'Assign project team and responsibilities', srNo: '1.2' },
        { key: 'landLeasing', name: 'Site identification and land leasing (DEWA requirements)', srNo: '1.3' },
        { key: 'siteSurvey', name: 'Site survey, geotechnical study, topography', srNo: '1.4' },

        // Design & Engineering
        { key: 'prelimDesign', name: 'Preliminary design & layout as per DEWA guidelines', srNo: '2.0' },
        { key: 'gridStudy', name: 'Grid study and interconnection plan', srNo: '2.1' },
        { key: 'finalDesign', name: 'Final electrical, civil, structural drawings', srNo: '2.2' },
        { key: 'yieldAnalysis', name: 'Shading and yield analysis (PVsyst)', srNo: '2.3' },
        { key: 'dewaCompliance', name: 'DEWA-specific design compliance', srNo: '2.4' },

        // Statutory Approvals
        { key: 'dewaGridApp', name: 'DEWA grid connection application', srNo: '3.0' },
        { key: 'dmApprovals', name: 'Dubai Municipality approvals', srNo: '3.1' },
        { key: 'environmentalClearance', name: 'Environmental Clearance (if required)', srNo: '3.2' },
        { key: 'civilDefence', name: 'Civil Defence No Objection Certificate', srNo: '3.3' },

        // Procurement
        { key: 'tendering', name: 'Tendering and BOQ finalization', srNo: '4.0' },
        { key: 'procurement', name: 'Procurement of DEWA-approved components', srNo: '4.1' },
        { key: 'importClearance', name: 'Import clearances (if any)', srNo: '4.2' },

        // Site Mobilization
        { key: 'siteFencing', name: 'Site fencing and access control', srNo: '5.0' },
        { key: 'siteOfficeSetup', name: 'Construction office and worker accommodation setup', srNo: '5.1' },
        { key: 'sitePlanning', name: 'Site safety and logistic planning', srNo: '5.2' },
        { key: 'materialArea', name: 'Material unloading area preparation', srNo: '5.3' },
        { key: 'temporaryUtilities', name: 'Temporary water and electricity arrangement', srNo: '5.4' },
        { key: 'safetyDeployment', name: 'Safety equipment deployment', srNo: '5.5' },

        // Civil Works
        { key: 'siteGrading', name: 'Site grading and leveling', srNo: '6.0' },
        { key: 'foundationMarking', name: 'Foundation marking and excavation', srNo: '6.1' },
        { key: 'foundationCasting', name: 'RCC foundation casting', srNo: '6.2' },
        { key: 'inverterRoomCivil', name: 'Inverter room/control room civil works', srNo: '6.3' },
        { key: 'cableTrench', name: 'Cable trench excavation and concreting', srNo: '6.4' },

        // Mounting Structure Installation
        { key: 'structureUnloading', name: 'Structure unloading and quality inspection', srNo: '7.0' },
        { key: 'structureAssembly', name: 'Structure assembly and erection', srNo: '7.1' },
        { key: 'alignmentCheck', name: 'Verticality and alignment check', srNo: '7.2' },
        { key: 'nutBolt', name: 'Nut-bolt tightening and torque check', srNo: '7.3' },

        // Module Installation
        { key: 'moduleUnloading', name: 'Module unloading and inspection', srNo: '8.0' },
        { key: 'moduleMounting', name: 'Module mounting on structures', srNo: '8.1' },
        { key: 'moduleTorquing', name: 'Torquing of modules', srNo: '8.2' },
        { key: 'moduleInspection', name: 'Cleaning and visual inspection', srNo: '8.3' },

        // DC Cabling & String Formation
        { key: 'dcLaying', name: 'DC cable laying', srNo: '9.0' },
        { key: 'mc4Crimping', name: 'MC4 connector crimping', srNo: '9.1' },
        { key: 'stringFormation', name: 'String formation and tagging', srNo: '9.2' },
        { key: 'irTesting', name: 'Polarity and insulation resistance testing', srNo: '9.3' },

        // Inverter and AC Works
        { key: 'inverterMounting', name: 'Inverter placement and mounting', srNo: '10.0' },
        { key: 'acdbPanel', name: 'ACDB, LT Panel installation', srNo: '10.1' },
        { key: 'acCabling', name: 'AC cable laying and termination', srNo: '10.2' },
        { key: 'transformerInstall', name: 'Transformer installation (if applicable)', srNo: '10.3' },
        { key: 'earthing', name: 'Earthing and LA installation', srNo: '10.4' },

        // SCADA and Communication
        { key: 'weatherStation', name: 'Weather station installation', srNo: '11.0' },
        { key: 'scadaMounting', name: 'SCADA panel and equipment mounting', srNo: '11.1' },
        { key: 'fiberLaying', name: 'Fiber/cable laying for communication', srNo: '11.2' },
        { key: 'systemIntegration', name: 'System integration and testing', srNo: '11.3' },
        { key: 'scadaMonitoring', name: 'SCADA and remote monitoring (DEWA interface)', srNo: '11.4' },

        // Testing & Commissioning
        { key: 'preCommissioning', name: 'Pre-commissioning checks (IR, polarity)', srNo: '12.0' },
        { key: 'inverterTesting', name: 'Functional testing of inverters', srNo: '12.1' },
        { key: 'gridSync', name: 'DEWA Grid synchronization', srNo: '12.2' },

        // Handover & Documentation
        { key: 'asBuilt', name: 'As-built drawing preparation', srNo: '13.0' },
        { key: 'reconciliation', name: 'Material reconciliation', srNo: '13.1' },
        { key: 'omTraining', name: 'O&M handover and training', srNo: '13.2' },
        { key: 'clientSignoff', name: 'Client handover with sign-off', srNo: '13.3' },
    ],
    tanzania: [
        // Project Initiation
        { key: 'kickoffFeasibility', name: 'Kickoff and feasibility study', srNo: '1.0' },
        { key: 'securePPA', name: 'Secure Power Purchase Agreement (PPA) with TANESCO or private offtaker', srNo: '1.1' },
        { key: 'landLease', name: 'Land lease with village/community or industrial zones', srNo: '1.2' },
        { key: 'siteSurvey', name: 'Site survey and geotechnical study', srNo: '1.3' },

        // Design & Engineering
        { key: 'systemDesign', name: 'System design as per EWURA & TANESCO codes', srNo: '2.0' },
        { key: 'loadFlowStudy', name: 'Load flow and grid impact studies', srNo: '2.1' },
        { key: 'finalDesign', name: 'Final technical design and layout', srNo: '2.2' },
        { key: 'yieldAssessment', name: 'Yield assessment and bankability review', srNo: '2.3' },

        // Statutory Approvals
        { key: 'tanescoConnection', name: 'TANESCO grid connection', srNo: '3.0' },
        { key: 'esiaNEMC', name: 'Environmental and Social Impact Assessment (NEMC)', srNo: '3.1' },
        { key: 'ewuraLicensing', name: 'EWURA licensing', srNo: '3.2' },
        { key: 'localPermits', name: 'Local authority permits', srNo: '3.3' },

        // Procurement
        { key: 'equipmentSpec', name: 'Equipment specification and vendor selection', srNo: '4.0' },
        { key: 'importCompliance', name: 'Import and tax compliance', srNo: '4.1' },
        { key: 'localMobilization', name: 'Local labor and contractor mobilization', srNo: '4.2' },

        // Site Mobilization
        { key: 'siteOffice', name: 'Site office setup', srNo: '5.0' },
        { key: 'materialArea', name: 'Material unloading area preparation', srNo: '5.1' },
        { key: 'temporaryUtilities', name: 'Temporary water and electricity arrangement', srNo: '5.2' },
        { key: 'safetyDeployment', name: 'Safety equipment deployment', srNo: '5.3' },

        // Civil Works
        { key: 'siteGrading', name: 'Site grading and leveling', srNo: '6.0' },
        { key: 'foundationMarking', name: 'Foundation marking and excavation', srNo: '6.1' },
        { key: 'foundationCasting', name: 'RCC foundation casting', srNo: '6.2' },
        { key: 'inverterRoomCivil', name: 'Inverter room/control room civil works', srNo: '6.3' },
        { key: 'cableTrench', name: 'Cable trench excavation and concreting', srNo: '6.4' },

        // Mounting Structure Installation
        { key: 'structureUnloading', name: 'Structure unloading and quality inspection', srNo: '7.0' },
        { key: 'structureAssembly', name: 'Structure assembly and erection', srNo: '7.1' },
        { key: 'alignmentCheck', name: 'Verticality and alignment check', srNo: '7.2' },
        { key: 'nutBolt', name: 'Nut-bolt tightening and torque check', srNo: '7.3' },

        // Module Installation
        { key: 'moduleUnloading', name: 'Module unloading and inspection', srNo: '8.0' },
        { key: 'moduleMounting', name: 'Module mounting on structures', srNo: '8.1' },
        { key: 'moduleTorquing', name: 'Torquing of modules', srNo: '8.2' },
        { key: 'moduleInspection', name: 'Cleaning and visual inspection', srNo: '8.3' },

        // DC Cabling & String Formation
        { key: 'dcLaying', name: 'DC cable laying', srNo: '9.0' },
        { key: 'mc4Crimping', name: 'MC4 connector crimping', srNo: '9.1' },
        { key: 'stringFormation', name: 'String formation and tagging', srNo: '9.2' },
        { key: 'irTesting', name: 'Polarity and insulation resistance testing', srNo: '9.3' },

        // Inverter and AC Works
        { key: 'inverterMounting', name: 'Inverter placement and mounting', srNo: '10.0' },
        { key: 'acdbPanel', name: 'ACDB, LT Panel installation', srNo: '10.1' },
        { key: 'acCabling', name: 'AC cable laying and termination', srNo: '10.2' },
        { key: 'transformerInstall', name: 'Transformer installation (if applicable)', srNo: '10.3' },
        { key: 'earthing', name: 'Earthing and LA installation', srNo: '10.4' },

        // SCADA and Communication
        { key: 'weatherStation', name: 'Weather station installation', srNo: '11.0' },
        { key: 'scadaMounting', name: 'SCADA panel and equipment mounting', srNo: '11.1' },
        { key: 'fiberLaying', name: 'Fiber/cable laying for communication', srNo: '11.2' },
        { key: 'systemIntegration', name: 'System integration and testing', srNo: '11.3' },

        // Testing & Commissioning
        { key: 'preCommissioning', name: 'Pre-commissioning checks (IR, polarity)', srNo: '12.0' },
        { key: 'inverterTesting', name: 'Functional testing of inverters', srNo: '12.1' },
        { key: 'gridSync', name: 'Grid synchronization with TANESCO Grid  compliance check', srNo: '12.2' },

        // Handover & Documentation
        { key: 'asBuilt', name: 'As-built drawing preparation', srNo: '13.0' },
        { key: 'reconciliation', name: 'Material reconciliation', srNo: '13.1' },
        { key: 'omTraining', name: 'O&M handover and training', srNo: '13.2' },
        { key: 'clientSignoff', name: 'Client handover with sign-off', srNo: '13.3' }
    ],

    botswana: [
        { key: 'projectFeasibilityIrr', name: 'Project feasibility and IRR analysis', srNo: '1.0' },
        { key: 'engageBPC', name: 'Engagement with Botswana Power Corporation (BPC)', srNo: '1.1' },
        { key: 'landAcquisition', name: 'Land acquisition with tribal authority or private', srNo: '1.2' },
        { key: 'siteSurveyTopo', name: 'Site survey and topographical analysis', srNo: '1.3' },

        { key: 'systemSizingLayout', name: 'System sizing and layout design', srNo: '2.0' },
        { key: 'envSocialStudy', name: 'Environmental & social study', srNo: '2.1' },
        { key: 'electricalDesignBotswana', name: 'Electrical design compliant with Botswana standards', srNo: '2.2' },
        { key: 'inverterConfig', name: 'Off-grid or grid-tied inverter configuration if applicable', srNo: '2.3' },

        { key: 'envApprovalDEA', name: 'Environmental approval (DEA Botswana)', srNo: '3.0' },
        { key: 'gridStudyBPC', name: 'Grid interconnection study by BPC', srNo: '3.1' },
        { key: 'devPermitsLocal', name: 'Local authority development permits', srNo: '3.2' },

        { key: 'tendering', name: 'Tendering & Vender Finalization', srNo: '4.0' },
        { key: 'poReleases', name: 'PO Releases & Advance Payment', srNo: '4.1' },
        { key: 'procureStructures', name: 'Procurement of Structures', srNo: '4.2' },
        { key: 'procureModules', name: 'Procurement of Modules', srNo: '4.3' },
        { key: 'procureInverters', name: 'Procurement of Inverters', srNo: '4.4' },
        { key: 'procureCables', name: 'Procurement of cables, SCB, LT Panels', srNo: '4.5' },
        { key: 'logisticsDelivery', name: 'Logistics & Delivery', srNo: '4.6' },

        { key: 'siteOfficeSetup', name: 'Site office setup', srNo: '5.0' },
        { key: 'materialUnloading', name: 'Material unloading area preparation', srNo: '5.1' },
        { key: 'tempWaterElectricity', name: 'Temporary water and electricity arrangement', srNo: '5.2' },
        { key: 'safetyDeployment', name: 'Safety equipment deployment', srNo: '5.3' },

        { key: 'siteGrading', name: 'Site grading and leveling', srNo: '6.0' },
        { key: 'foundationExcavation', name: 'Foundation marking and excavation', srNo: '6.1' },
        { key: 'rccCasting', name: 'RCC foundation casting', srNo: '6.2' },
        { key: 'roomCivilWorks', name: 'Inverter room/control room civil works', srNo: '6.3' },
        { key: 'trenchConcreting', name: 'Cable trench excavation and concreting', srNo: '6.4' },

        { key: 'structureUnloading', name: 'Structure unloading and quality inspection', srNo: '7.0' },
        { key: 'structureErection', name: 'Structure assembly and erection', srNo: '7.1' },
        { key: 'alignmentCheck', name: 'Verticality and alignment check', srNo: '7.2' },
        { key: 'torqueCheck', name: 'Nut-bolt tightening and torque check', srNo: '7.3' },

        { key: 'moduleUnloading', name: 'Module unloading and inspection', srNo: '8.0' },
        { key: 'moduleMounting', name: 'Module mounting on structures', srNo: '8.1' },
        { key: 'moduleTorquing', name: 'Torquing of modules', srNo: '8.2' },
        { key: 'moduleInspection', name: 'Cleaning and visual inspection', srNo: '8.3' },

        { key: 'dcCableLaying', name: 'DC cable laying', srNo: '9.0' },
        { key: 'mc4Crimping', name: 'MC4 connector crimping', srNo: '9.1' },
        { key: 'stringTagging', name: 'String formation and tagging', srNo: '9.2' },
        { key: 'irTesting', name: 'Polarity and insulation resistance testing', srNo: '9.3' },

        { key: 'inverterMounting', name: 'Inverter placement and mounting', srNo: '10.0' },
        { key: 'acdbInstallation', name: 'ACDB, LT Panel installation', srNo: '10.1' },
        { key: 'acCableLaying', name: 'AC cable laying and termination', srNo: '10.2' },
        { key: 'transformerInstall', name: 'Transformer installation', srNo: '10.3' },
        { key: 'earthingLA', name: 'Earthing and LA installation', srNo: '10.4' },

        { key: 'weatherStation', name: 'Weather station installation', srNo: '11.0' },
        { key: 'scadaMounting', name: 'SCADA panel and equipment mounting', srNo: '11.1' },
        { key: 'fiberLaying', name: 'Fiber/cable laying for communication', srNo: '11.2' },
        { key: 'scadaTesting', name: 'System integration and testing', srNo: '11.3' },

        { key: 'preCommissioning', name: 'Pre-commissioning checks (IR, polarity)', srNo: '12.0' },
        { key: 'functionalTest', name: 'Functional testing of inverters', srNo: '12.1' },
        { key: 'bpcInspection', name: 'BPC inspection Testing for commissioning', srNo: '12.2' },
        { key: 'gridSync', name: 'Grid synchronization', srNo: '12.3' },

        { key: 'asBuiltDrawing', name: 'As-built drawing preparation', srNo: '13.0' },
        { key: 'materialRecon', name: 'Material reconciliation', srNo: '13.1' },
        { key: 'omHandover', name: 'O&M handover and training', srNo: '13.2' },
        { key: 'clientSignoff', name: 'Client handover with sign-off', srNo: '13.3' }
    ],


    kenya: [
        { key: 'projectScopingFinancing', name: 'Project scoping and financing', srNo: '1.0' },
        { key: 'securePpa', name: 'Secure PPA with KPLC or captive offtaker', srNo: '1.1' },
        { key: 'communityLandLease', name: 'Community consultation and land lease', srNo: '1.2' },
        { key: 'soilTopoAnalysis', name: 'Soil and topography analysis', srNo: '1.3' },

        { key: 'gridImpactStudy', name: 'Grid impact and feasibility study', srNo: '2.0' },
        { key: 'epraDesignCompliance', name: 'Design as per Energy and Petroleum Regulatory Authority (EPRA)', srNo: '2.1' },
        { key: 'finalLayoutDocs', name: 'Final system layout and technical documents', srNo: '2.2' },
        { key: 'pvsystModeling', name: 'PVsyst simulation and electrical modeling', srNo: '2.3' },

        { key: 'epraLicensing', name: 'EPRA licensing (Energy and Petroleum Regulatory Authority, Kenya)', srNo: '3.0' },
        { key: 'nemaAssessment', name: 'Environmental and Social Impact Assessment (NEMA Kenya)', srNo: '3.1' },
        { key: 'countyPermits', name: 'County Government & local authority permits', srNo: '3.2' },
        { key: 'kplcInterconnection', name: 'KPLC grid interconnection approval', srNo: '3.3' },

        { key: 'tendering', name: 'Tendering & Vender Finalization', srNo: '4.0' },
        { key: 'poReleases', name: 'PO Releases & Advance Payment', srNo: '4.1' },
        { key: 'procureStructures', name: 'Procurement of Structures', srNo: '4.2' },
        { key: 'procureModules', name: 'Procurement of Modules', srNo: '4.3' },
        { key: 'procureInverters', name: 'Procurement of Inverters', srNo: '4.4' },
        { key: 'procureCables', name: 'Procurement of cables, SCB, LT Panels', srNo: '4.5' },
        { key: 'logisticsDelivery', name: 'Logistics & Delivery', srNo: '4.6' },

        { key: 'siteOfficeSetup', name: 'Site office setup', srNo: '5.0' },
        { key: 'materialUnloading', name: 'Material unloading area preparation', srNo: '5.1' },
        { key: 'temporaryUtilities', name: 'Temporary water and electricity arrangement', srNo: '5.2' },
        { key: 'safetyDeployment', name: 'Safety equipment deployment', srNo: '5.3' },

        { key: 'siteGrading', name: 'Site grading and leveling', srNo: '6.0' },
        { key: 'foundationMarking', name: 'Foundation marking and excavation', srNo: '6.1' },
        { key: 'rccCasting', name: 'RCC foundation casting', srNo: '6.2' },
        { key: 'civilWorksRoom', name: 'Inverter room/control room civil works', srNo: '6.3' },
        { key: 'trenchExcavation', name: 'Cable trench excavation and concreting', srNo: '6.4' },

        { key: 'structureUnloading', name: 'Structure unloading and quality inspection', srNo: '7.0' },
        { key: 'structureErection', name: 'Structure assembly and erection', srNo: '7.1' },
        { key: 'alignmentCheck', name: 'Verticality and alignment check', srNo: '7.2' },
        { key: 'torqueCheck', name: 'Nut-bolt tightening and torque check', srNo: '7.3' },

        { key: 'moduleUnloading', name: 'Module unloading and inspection', srNo: '8.0' },
        { key: 'moduleMounting', name: 'Module mounting on structures', srNo: '8.1' },
        { key: 'moduleTorquing', name: 'Torquing of modules', srNo: '8.2' },
        { key: 'moduleCleaning', name: 'Cleaning and visual inspection', srNo: '8.3' },

        { key: 'dcCableLaying', name: 'DC cable laying', srNo: '9.0' },
        { key: 'mc4Crimping', name: 'MC4 connector crimping', srNo: '9.1' },
        { key: 'stringFormation', name: 'String formation and tagging', srNo: '9.2' },
        { key: 'irPolarityTesting', name: 'Polarity and insulation resistance testing', srNo: '9.3' },

        { key: 'inverterMounting', name: 'Inverter placement and mounting', srNo: '10.0' },
        { key: 'acdbInstallation', name: 'ACDB, LT Panel installation', srNo: '10.1' },
        { key: 'acCableTermination', name: 'AC cable laying and termination', srNo: '10.2' },
        { key: 'transformerInstallation', name: 'Transformer installation (if applicable)', srNo: '10.3' },
        { key: 'earthingInstallation', name: 'Earthing and LA installation', srNo: '10.4' },

        { key: 'weatherStationInstall', name: 'Weather station installation', srNo: '11.0' },
        { key: 'scadaMounting', name: 'SCADA panel and equipment mounting', srNo: '11.1' },
        { key: 'fiberLaying', name: 'Fiber/cable laying for communication', srNo: '11.2' },
        { key: 'systemTesting', name: 'System integration and testing', srNo: '11.3' },

        { key: 'preCommissioning', name: 'Pre-commissioning checks (IR, polarity)', srNo: '12.0' },
        { key: 'inverterTesting', name: 'Functional testing of inverters', srNo: '12.1' },
        { key: 'inspectionClearance', name: 'Inspection and clearance', srNo: '12.2' },
        { key: 'gridSynchronization', name: 'Grid synchronization', srNo: '12.3' },

        { key: 'asBuiltDrawings', name: 'As-built drawing preparation', srNo: '13.0' },
        { key: 'materialReconciliation', name: 'Material reconciliation', srNo: '13.1' },
        { key: 'omHandoverTraining', name: 'O&M handover and training', srNo: '13.2' },
        { key: 'clientSignoff', name: 'Client handover with sign-off', srNo: '13.3' }
    ]

};

export const ROOFTOP_TASKS = {
    // { key: 'overallProgress', name: 'Overall Progress', srNo: '0.0' },
    // Vendor Finalization
    india: [
        { key: 'vendorFinalization', name: 'Vendor Finalisation', srNo: '1.0' },
        { key: 'issuingPO', name: 'Issuing PO to Vendor and getting ACK copy', srNo: '1.1' },
        { key: 'epcAgreement', name: 'EPC Agreement and collecting PDC', srNo: '1.2' },
        { key: 'safetyUndertaking', name: 'Collecting Safety Undertaking', srNo: '1.3' },
        // Design Activities
        { key: 'designActivities', name: 'Design Related Activities', srNo: '2.0' },
        { key: 'kickoffMeeting', name: 'Kick off meeting with customer and Site visit', srNo: '2.1' },
        { key: 'detailedEngineering', name: 'Detailed Engineering: Design Preparation', srNo: '2.2' },
        { key: 'designSubmission', name: 'Design Submission to customer for approval', srNo: '2.3' },
        { key: 'customerApproval', name: 'Approval from customer', srNo: '2.4' },
        // Material Ordering
        { key: 'orderingMaterials', name: 'Ordering Materials-PO release', srNo: '3.0' },
        { key: 'bomPreparation', name: 'BOM preparation', srNo: '3.1' },
        { key: 'solarModulePO', name: 'Solar Module', srNo: '3.2' },
        { key: 'inverterPO', name: 'Inverter', srNo: '3.3' },
        { key: 'acdbPanelPO', name: 'ACDB/LT Panel', srNo: '3.4' },
        { key: 'mmsPO', name: 'MMS (Module Mounting Structure)', srNo: '3.5' },
        { key: 'lifelinePO', name: 'Lifeline', srNo: '3.6' },
        { key: 'walkwayPO', name: 'Walkway', srNo: '3.7' },
        { key: 'lightningArresterPO', name: 'Lightning Arrestor & Earthing Material', srNo: '3.8' },
        { key: 'bosMaterialPO', name: 'BOS Material', srNo: '3.9' },
        { key: 'moduleCleaningPO', name: 'Module cleaning system materials', srNo: '3.10' },
        { key: 'cablesPO', name: 'AC, DC and Communication Cables', srNo: '3.11' },
        { key: 'rmsPO', name: 'RMS- complete system', srNo: '3.12' },
        // Material Delivery
        { key: 'materialDelivery', name: 'Material delivery', srNo: '4.0' },
        { key: 'solarModuleDelivery', name: 'Solar Module', srNo: '4.1' },
        { key: 'inverterDelivery', name: 'Inverter', srNo: '4.2' },
        { key: 'acdbPanelDelivery', name: 'ACDB/LT Panel', srNo: '4.3' },
        { key: 'mmsDelivery', name: 'MMS (Module Mounting Structure)', srNo: '4.4' },
        { key: 'lifelineDelivery', name: 'Lifeline', srNo: '4.5' },
        { key: 'walkwayDelivery', name: 'Walkway and wire mesh', srNo: '4.6' },
        { key: 'lightningArresterDelivery', name: 'Lightning Arrestor & Earthing Material', srNo: '4.7' },
        { key: 'bosMaterialDelivery', name: 'BOS Material', srNo: '4.8' },
        { key: 'moduleCleaningDelivery', name: 'Module cleaning system materials', srNo: '4.9' },
        { key: 'cablesDelivery', name: 'AC, DC and Communication Cables', srNo: '4.10' },
        { key: 'rmsDelivery', name: 'RMS- complete system', srNo: '4.11' },
        // Execution
        { key: 'execution', name: 'Execution', srNo: '5.0' },
        { key: 'manpowerMobilization', name: 'Manpower Documentation & Mobilisation', srNo: '5.1' },
        { key: 'sitePreparation', name: 'Site Preparation', srNo: '5.2' },
        { key: 'lifelineInstallation', name: 'Lifeline Installation', srNo: '5.3' },
        { key: 'walkwayInstallation', name: 'Walkway Installation', srNo: '5.4' },
        { key: 'wireMeshInstallation', name: 'Wire Mesh Installation', srNo: '5.5' },
        { key: 'mmsMarking', name: 'MMS marking', srNo: '5.6' },
        { key: 'mmsInstallation', name: 'MMS installation', srNo: '5.7' },
        { key: 'moduleShifting', name: 'PV Module Shifting', srNo: '5.8' },
        { key: 'moduleInstallation', name: 'PV module Installation', srNo: '5.9' },
        { key: 'earthingPit', name: 'Earthing Pit Excavation, Refilling', srNo: '5.10' },
        { key: 'laInstallation', name: 'LA installation', srNo: '5.11' },
        { key: 'inverterInstallation', name: 'Inverter Installation Including Civil Work', srNo: '5.12' },
        { key: 'ltInstallation', name: 'LT/ACDB Installation Including Civil Work', srNo: '5.13' },
        { key: 'earthingConnection', name: 'Earthing Connection for MMS, LA, Inverter & ACDB', srNo: '5.14' },
        { key: 'cableTrayInstallation', name: 'AC & DC Cable Tray Installation', srNo: '5.15' },
        { key: 'dcStringing', name: 'DC stringing and DC cable laying', srNo: '5.16' },
        { key: 'acCableLaying', name: 'AC Cable Laying', srNo: '5.17' },
        { key: 'termination', name: 'DC and AC termination', srNo: '5.18' },
        { key: 'interconnection', name: 'Interconnection & Test Run', srNo: '5.19' },
        { key: 'communication', name: 'Communication Cabling & RMS Activity', srNo: '5.20' },
        // CEIG Approvals
        { key: 'ceigApprovals', name: 'Statutory Approvals- CEIG', srNo: '6.0' },
        { key: 'ceigDocCollection', name: 'Collection of Documents for statutory approvals', srNo: '6.1' },
        { key: 'ceigPlanApplication', name: 'Application for CEIG plan approval', srNo: '6.2' },
        { key: 'ceigPlanApproval', name: 'Receiving of CEIG plan approval', srNo: '6.3' },
        { key: 'ceigChargingApplication', name: 'Application for CEIG charging permission', srNo: '6.4' },
        { key: 'ceigInspection', name: 'Work completion visit from CEIG officer', srNo: '6.5' },
        { key: 'ceigPermission', name: 'Receiving final charging permission', srNo: '6.6' },
        // DISCOM Approvals
        { key: 'discomApprovals', name: 'Statutory Approvals-DISCOM', srNo: '7.0' },
        { key: 'discomDocCollection', name: 'Collection of Documents for statutory approvals', srNo: '7.1' },
        { key: 'discomSubmission', name: 'Initial Document Submission at DISCOM', srNo: '7.2' },
        { key: 'discomVisit', name: 'DISCOM technical feasibility visit', srNo: '7.3' },
        { key: 'feasibilityReport', name: 'Obtaining feasibility report and point of supply', srNo: '7.4' },
        { key: 'sanctionOrder', name: 'Sanction order from DISCOM', srNo: '7.5' },
        { key: 'meterPurchase', name: 'CT and Meter purchase and testing', srNo: '7.6' },
        { key: 'gmPanel', name: 'GM panel fabrication and Installation', srNo: '7.7' },
        { key: 'discomWorkCompletion', name: 'Work completion Visit from DISCOM', srNo: '7.8' },
        { key: 'netMeterAgreement', name: 'Net meter Agreement', srNo: '7.9' },
        { key: 'releaseOrder', name: 'Release order', srNo: '7.10' },
        { key: 'netMeterInstallation', name: 'Net Meter Installation', srNo: '7.11' },
        // Commissioning
        { key: 'commissioning', name: 'Commissioning & Hand Over', srNo: '8.0' },
        { key: 'plantCharging', name: 'Charging of Solar Plant', srNo: '8.1' },
        { key: 'qaInspection', name: 'DE QA Inspection Activity', srNo: '8.2' },
        { key: 'punchPoints', name: 'QA Punch Point clearing', srNo: '8.3' },
        { key: 'stabilization', name: 'Plant Stabilization test', srNo: '8.4' },
        { key: 'documentation', name: 'All project related documents from Vendor', srNo: '8.5' },
        { key: 'handover', name: 'Plant Hand Over to AM team', srNo: '8.6' }
    ]
};

// Helper functions
export const getTasksBySection = tasks => tasks.reduce((acc, task) => {
    const section = Math.floor(parseFloat(task.srNo));
    acc[section] = acc[section] || [];
    acc[section].push(task);
    return acc;
}, {});

export const getEffectiveCountry = (inputCountry) => {
    // Priority: input > sessionStorage > fallback
    return (
        inputCountry?.toLowerCase() ||
        sessionStorage.getItem('country')?.toLowerCase() ||
        'india'
    );
};


export const getSectionName = sectionNumber => SECTIONS[sectionNumber] || 'Unknown Section';

export const getTasksForType = (projectType, country) => {
    const effectiveCountry = getEffectiveCountry(country);
    if (projectType === 'groundmount') {
        return GROUND_MOUNT_TASKS[effectiveCountry] || [];
    }
    return ROOFTOP_TASKS['india'];
};

export const calculateProgress = (completedQty, budgetedQty) => {
    if (!budgetedQty || !completedQty) return 0;
    const progress = (parseFloat(completedQty) / parseFloat(budgetedQty)) * 100;
    return Math.min(Math.round(progress), 100);
};

export const calculateSectionProgress = tasks => {
    if (!tasks?.length) return 0;
    return Math.round(tasks.reduce((sum, task) => sum + (task.progress || 0), 0) / tasks.length);
};